export function convertToHyphenSeparatedAlphaNumeric(target: string): string {
    return target.trim().toLocaleLowerCase().replace(/\W+/g, '-');
}